import * as React from 'react';
export const solSvg = React.forwardRef(function solSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#10111A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M9.873 20.41a.645.645 0 0 1 .476-.21l14.662.012a.323.323 0 0 1 .238.54l-3.123 3.438a.643.643 0 0 1-.475.21l-14.662-.012a.323.323 0 0 1-.238-.54l3.122-3.438Zm15.376-2.862a.322.322 0 0 1-.238.54l-14.662.012a.642.642 0 0 1-.476-.21l-3.122-3.44a.323.323 0 0 1 .238-.54l14.662-.012a.644.644 0 0 1 .475.21l3.123 3.44ZM9.873 7.81a.644.644 0 0 1 .476-.21l14.662.012a.322.322 0 0 1 .238.54l-3.123 3.438a.643.643 0 0 1-.475.21l-14.662-.012a.323.323 0 0 1-.238-.54L9.873 7.81Z',
      fill: 'url(#bi_sol__a)',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_sol__a',
          x1: 7.233,
          y1: 24.766,
          x2: 24.766,
          y2: 7.234,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#9945FF',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.2,
          stopColor: '#7962E7',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#00D18C',
        }),
      ),
    ),
  );
});
solSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sol = {
  category: 'brand',
  colorable: false,
  name: 'sol',
  svg: solSvg,
};
